import { z } from "zod";

export const renewMissionSchema = (t: (key: string) => string) =>
  z.object({
    renewDate: z
      .string()
      .nonempty(t("global.form.error.mandatoryField"))
      .refine(
        (dateString) => {
          if (!dateString) return false;
          const inputDate = new Date(dateString);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return inputDate > today;
        },
        { message: t("global.form.error.dateInPast") }
      )
      .refine(
        (dateString) => {
          if (!dateString) return false;
          const inputDate = new Date(dateString);
          const today = new Date();
          const maxDate = new Date(today);
          maxDate.setFullYear(today.getFullYear() + 2);
          return inputDate <= maxDate;
        },
        { message: t("global.form.error.dateTooFarInFuture") }
      ),
  });
export type RenewMissionFormValues = z.infer<ReturnType<typeof renewMissionSchema>>;
